import React, { useState } from "react";
import DashboardLayout from "../../../../Layout/DashboardLayout";
import { Steps, message } from "antd";
import Button from "Components/Button";
import Back from "Components/Back";
import ProductDetails from "./Components/ProductDetails";
import BranchSelection from "./Components/BranchSelection";
import ProductSelection from "./Components/ProductSelection";

const AddInventory = () => {
  const [payload, setPayload] = useState({
    description: "",
    purpose: "",
    branchId: "",
    type: "",
    products: [],
  });
  const [current, setCurrent] = useState(0);

  const steps = [
    {
      title: "Description",
      content: <ProductDetails payload={payload} setPayload={setPayload} />,
    },
    {
      title: "Branch Selection",
      content: <BranchSelection payload={payload} setPayload={setPayload} />,
    },
    {
      title: "Product Selection",
      content: <ProductSelection payload={payload} setPayload={setPayload} />,
    },
  ];

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const handleFinish = () => {
    message.success("Inventory Added Successfully");
    // Final action here (e.g., form submission)
  };

  const items = steps.map((item) => ({ key: item.title, title: item.title }));

  return (
    <DashboardLayout title="Add Inventory" back={false}>
      <div className="px-8 py-6 bg-gray-100 rounded-lg">
        <Back />
        <div className="w-[600px] mx-auto mt-[40px] border-[1px] border-[#eeeeee] p-[20px] rounded-[10px]">
          <Steps current={current} items={items} />
          <div className="h-[400px] mt-6">{steps[current].content}</div>
          <div className="flex justify-between mt-6 gap-[20px]">
            {current > 0 && (
              <Button
                onClick={prev}
                label="Previous"
                disabled={false}
                isLoading={false}
              />
            )}
            {current < steps.length - 1 ? (
              <Button
                onClick={next}
                label="Next"
                disabled={false}
                isLoading={false}
              />
            ) : (
              <Button
                onClick={handleFinish}
                label="Finish"
                disabled={false}
                isLoading={false}
              />
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AddInventory;
